import { Toaster } from "react-hot-toast";

const Toast = () => {
  return (
    <Toaster
      position="top-right"
      reverseOrder={false}
      containerStyle={{
        zIndex: 99999,
      }}
    />
  );
};

export default Toast;

